module.exports = __webpack_public_path__ + "static/avatar-image-3248f31d0989cb9cddf053156c0d7a5e.png";